import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabaseHelpers } from '../lib/supabase';

const DebugPage = () => {
  const { user } = useAuth();
  const [ordersInStorage, setOrdersInStorage] = useState([]);
  const [userInStorage, setUserInStorage] = useState(null);

  useEffect(() => {
    // Check localStorage
    const orders = localStorage.getItem('orders');
    const demoUser = localStorage.getItem('demoUser');
    
    setOrdersInStorage(orders ? JSON.parse(orders) : []);
    setUserInStorage(demoUser ? JSON.parse(demoUser) : null);
  }, []);

  const clearAll = () => {
    localStorage.removeItem('orders');
    localStorage.removeItem('demoUser');
    setOrdersInStorage([]);
    setUserInStorage(null);
    alert('Cleared all data!');
  };

  const testSaveOrder = async () => {
    if (!user) {
      alert('Please sign in first!');
      return;
    }

    const testOrder = {
      user_id: user.id,
      user_email: user.email,
      order_date: new Date().toISOString().split('T')[0],
      status: 'pending',
      homeowner_name: 'Test User',
      homeowner_email: user.email,
      homeowner_phone: '555-1234',
      property_address: '123 Test St',
      property_type: 'Single Family',
      project_type: 'Roof Replacement',
      contractor_name: 'Test Contractor',
      contractor_contact: 'John Doe',
      contractor_phone: '555-5678',
      contractor_email: 'contractor@test.com',
      contractor_address: '456 Contractor Ave',
      contractor_rating: 4.5,
      contractor_avatar: '',
      total_cost: 5000,
      timeline: '3-5 days',
      warranty: '10 years',
      materials: 'Asphalt Shingles',
      scheduled_date: new Date().toISOString().split('T')[0],
      preferred_time: '9:00 AM',
      alternate_date: null,
      alternate_time: null,
      completion_date: null,
      roof_measurements: {
        totalArea: 2000,
        pitchedArea: 1800,
        flatArea: 200
      },
      contact_method: 'phone',
      special_instructions: '',
      access_instructions: '',
      emergency_contact: '',
      payment_method: 'payment-plan',
      bid_details: {}
    };

    console.log('Creating test order with user_id:', user.id, 'and user_email:', user.email);
    const result = await supabaseHelpers.saveOrder(testOrder);
    console.log('Test order save result:', result);
    
    if (result.success) {
      alert('Test order saved! Check localStorage and go to /orders to see it.');
      window.location.reload();
    } else {
      alert('Failed to save test order: ' + JSON.stringify(result.error));
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Debug Page</h1>
        
        {/* Current User */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Current User</h2>
          {user ? (
            <pre className="bg-gray-100 p-4 rounded overflow-auto">
              {JSON.stringify(user, null, 2)}
            </pre>
          ) : (
            <p className="text-gray-500">No user logged in</p>
          )}
        </div>

        {/* User in LocalStorage */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">User in LocalStorage</h2>
          {userInStorage ? (
            <pre className="bg-gray-100 p-4 rounded overflow-auto">
              {JSON.stringify(userInStorage, null, 2)}
            </pre>
          ) : (
            <p className="text-gray-500">No user in localStorage</p>
          )}
        </div>

        {/* Orders in LocalStorage */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">
            Orders in LocalStorage ({ordersInStorage.length})
          </h2>
          {ordersInStorage.length > 0 ? (
            <pre className="bg-gray-100 p-4 rounded overflow-auto max-h-96">
              {JSON.stringify(ordersInStorage, null, 2)}
            </pre>
          ) : (
            <p className="text-gray-500">No orders in localStorage</p>
          )}
        </div>

        {/* Actions */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Actions</h2>
          <div className="space-y-3">
            <button
              onClick={testSaveOrder}
              className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700"
            >
              Save Test Order
            </button>
            <button
              onClick={clearAll}
              className="w-full bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700"
            >
              Clear All Data
            </button>
            <button
              onClick={() => window.location.reload()}
              className="w-full bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700"
            >
              Refresh Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebugPage;
